import React, { Component } from 'react';
import firebase from 'firebase';
import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table';
import Modal from 'react-modal';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import './modal.css';
import secondaryApp from '../BD/secondaryApp';


const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px',
	height: '500px'
  }
};


class modal_tipoviajes extends Component {
	
	constructor(){
		
		super();
		this.state={
			
			paradas:true,

		};
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.llenar=this.llenar.bind(this);
		this.tiposViajes=database.ref().child('TiposViajes');
		this.empleadosGPSRef=database.ref().child('EmpleadosGPS');
		this.sociosRef=database.ref().child('Socios');
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.handleInputChange = this.handleInputChange.bind(this);
	}
	
	
	componentWillMount(){
		
		Modal.setAppElement('body');
	}
	
	
	componentDidMount(){

	}

	llenar(){
		
		
		this.state.vehiculos=this.state.vehiculos1
	}
	
	
	toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0,
			placa:'',
			socio:'',
			socioKey:'',
			modelo:'',
			marca:''
			
		})
		
	}


	handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }

	
	//handle para envio del formulario
	handleSubmit(event){
		this.tiposViajes.push({		
			nombre:this.nombretipoviaje.value,
			descripcion:this.descripcion.value,
			paradas:this.state.paradas,
			estado:'activo'
		});
		
		event.preventDefault();

		Alert.success('Datos guardados correctamente', {
			effect: 'genie',
			position: 'bottom-right',
			timeout:2000			
		});
		
		this.toggleModal();
	}
	
	
	//handle para seleccion de socios
	handleClick = (rowKey) => {
		
		
	}

	//handle para modal seleccion de vehiculos
	handleClickVehiculos=(rowKey)=>{
		
		this.setState({
			
			placa:rowKey.key,
			marca:rowKey.marca+' ',
			modelo:rowKey.modelo
		});
		
		this.toggleModalVehiculos();
		
	}
	
	
	
  render() {
    return (
		
		
		
      
        <div className="modal_empleados">
			
			
			
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
				
						<h2>Tipos de Viajes</h2>
						<hr/>
				
						<form method="POST" action="" onSubmit={this.handleSubmit}>
							
							<div className="form-group">
								<label htmlFor="nombre">Nombre</label>
								<input type="text" name="nombre" className="form-control"
								placeholder="Nombre" required autoComplete="off"
								ref={input => {this.nombretipoviaje=input;}}
								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="dui">Descripcion</label>
								
								<textarea className="form-control" 
								placeholder="Dui" required autoComplete="off"
								ref={input => {this.descripcion=input;}}
								/>
							</div>
							<div className="col-5 col-md-5 form-check" style={{left: '15px' }}>
								<div className="form-group row">
									<label htmlFor='paradas'>Paradas</label>
									<input type="checkbox" onChange={this.handleInputChange} name='paradas' className="form-check-input" id="paradas" checked={this.state.paradas} />
								</div>
							</div>
							
							<br/>
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
					</form>	
					
					
					</Modal>
		</div>
      
    );
  }
}

export default modal_tipoviajes;



// WEBPACK FOOTER //
// ./src/Components/Tipo_Viajes/modal_tipoviajes.js